<template>
<div>
  <v-img style="margin-top: -60px; z-index: 0;transform: translateY(3px);" contain position="center right" :src="require('@/assets/bg_bottom.svg')"></v-img>
  <v-footer
      height="auto"
      color="footTop"
      width="100%"
      padless
    >

      <v-card
        flat
        justify-center
        column
        wrap
        class="footTop white--text text-center flex-grow-1 p-0"
      >
      <div>
        <h2 class="footer-logo">she</h2>
          <p class="address">111 NE 1st Street<br>8th Floor #1030<br>Miami, FL 33132</p>
          <v-tooltip v-for="icon in icons" :key="icon.name" bottom>
            <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-on="on"
              class="mx-3 white--text"
              icon
              v-bind="attrs"
              :href="icon.link"
              target="_blank"
            >
              <v-icon size="24px">{{ icon.name }}</v-icon>
            </v-btn>
            </template>
            <span>{{icon.platform}}</span>
          </v-tooltip>
      </div>
      <div class="flex">
        <Terms></Terms>
        <Privacy></Privacy>
      </div>
        <v-flex
          footBottom
          py-3
          mt-4
          text-xs-center
          xs12
          style="color: #7A90A4"
        >
          &copy;{{ new Date().getFullYear() }} ShePlatform | All Rights Reserved
        </v-flex>
      </v-card>
    </v-footer>
</div>
</template>

<script>
import Terms from "./Terms.vue";
import Privacy from "./Privacy.vue";

export default {
  data() {
    return {
      icons: [
        {
          platform: 'Like us on Facebook',
          name: 'fab fa-facebook',
          link: 'https://www.facebook.com/shebarters'
        },
        {
          platform: 'Follow us on Twitter',
          name: 'fab fa-twitter',
          link: 'https://twitter.com/shebarters'
        },
        {
          platform: 'Pin us on Pinterest',
          name: 'fab fa-pinterest',
          link: 'https://www.pinterest.com/sheplatform/'
        },
        {
          platform: 'Connect on Linked In',
          name: 'fab fa-linkedin',
          link: 'https://www.linkedin.com/company/she-platfrom/about/'
        },
        {
          platform: 'Follow us on Instagram',
          name: 'fab fa-instagram',
          link: 'https://www.instagram.com/sheplatform/'
        },
        {
          platform: 'Follow us on Youtube',
          name: 'fab fa-youtube',
          link: 'https://www.youtube.com/channel/UCWt25n0Nm2DCb3iWL-eFXYg/featured'
        },
        {
          platform: 'Join us on Telegram',
          name: 'fab fa-telegram',
          link: 'https://t.me/sheplatfom'
        }
      ]
    }
  },
  components: {
    Terms,
    Privacy
  }
}
</script>

<style>
.address {
    color: #fff;
    font-size: large;
    font-family: "Open Sans", sans-serif;
}
.footer-logo {
  font-size: 74px;
  color: white;
  font-family: 'Baloo', sans-serif
}
</style>
